export const NEW_MESSAGE = 'newMessage';
export const NOTIFICATION = 'socketNotification';
export const SEND_MESSAGE = 'sendMessage';
export const SEND_MESSAGE_SUCCEED = 'sendMessageSucceed';
export const SEND_MESSAGE_FAILED = 'sendMessageFailed';
export const FILE_HUB_STATUS_CHANGE = 'fileHubStatusChange';
export const FILE_HUB_REMOVE = 'fileHubRemove';
